export enum QUERY_KEYS {
  addGuest = 'add-guest',
}
